module.exports = __webpack_public_path__ + "img/ico-irpf.d2ff09c3.svg";